import { render, staticRenderFns } from "./PermissionsList.vue?vue&type=template&id=57dc3bf0&scoped=true"
import script from "./PermissionsList.vue?vue&type=script&lang=js"
export * from "./PermissionsList.vue?vue&type=script&lang=js"
import style0 from "./PermissionsList.vue?vue&type=style&index=0&id=57dc3bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dc3bf0",
  null
  
)

export default component.exports